import { IOption } from 'types';

export function convertToOptions(arr: { id: number; name: string }[]): IOption<number, string>[] {
  return arr.map((item) => ({
    value: item.id,
    label: item.name,
  }));
}
